// GLOBAL
export const DEFAULT_CROP_RATIO = 1;
export const DEFAULT_SHOW_MORE_HEIGHT = 157;
export const GALLERY_TYPES = {
  FEED: 'FEED',
  HASHTAG: 'HASHTAG',
  STORY: 'STORY',
};

// GalleryLayout - Grid, Collage, slider
export const GALLERY_LAYOUT_GRID = 2;
export const GALLERY_LAYOUT_COLLAGE = -1;
export const GALLERY_LAYOUT_SLIDER = 4;

// GallerySizePx (Collage Size) - Small, Medium, Large
export const GALLERY_SIZE_COLLAGE_SMALL = 400;
export const GALLERY_SIZE_COLLAGE_MEDIUM = 600;
export const GALLERY_SIZE_COLLAGE_LARGE = 800;

// DESK
export const DESK_DEFAULT_SPACE_BETWEEN_ITEMS = 20;
export const DESK_DEFAULT_SPACE_GALLERY = 20;
export const DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW = 3;
export const DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW_HASHTAG = 5;
export const DESK_DEFAULT_COUNT_ROWS = 2;
export const TABLET_GRID_MAX_ITEM_IN_ROW = 3;
export const DESK_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW = 5;

// SLIDER SETTINGS
export const SLIDER_ARROW_SETTINGS = {
  SIZE: 24,
  PADDING: 38,
  POSITION: { IN: 0, OUT: 1 },
};

export const SLIDER_ARROW_SETTINGS_MOBILE = {
  SIZE: 18,
  PADDING: 6,
  POSITION: { IN: 0, OUT: 1 },
};

// MOBILE
export const MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS = 4;
export const MOBILE_GRID_DEFAULT_COUNT_ITEM_IN_ROW = 3;
export const MOBILE_DEFAULT_COUNT_ROWS = 3;
export const MOBILE_COLLAGE_GALLERY_SIZE = 800;
export const MOBILE_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW = 3;

export const GLOBAL_OPTIONS = {
  textBoxHeight: 0,
  titlePlacement: 'SHOW_ON_HOVER',
  hoveringBehaviour: 'NO_CHANGE',
  overlayAnimation: 'FADE_IN',
  overlayBackground: 'rgba(8,8,8,0)',
  galleryMargin: DESK_DEFAULT_SPACE_GALLERY,
  videoLoop: false,
  allowContextMenu: true,
  arrowsSize: SLIDER_ARROW_SETTINGS.SIZE,
  arrowsPadding: SLIDER_ARROW_SETTINGS.PADDING,
  arrowsPosition: SLIDER_ARROW_SETTINGS.POSITION.IN,
};

export const GRID_LAYOUT = {
  ...GLOBAL_OPTIONS,
  galleryLayout: GALLERY_LAYOUT_GRID,
  gridStyle: 1,
  galleryMargin: DESK_DEFAULT_SPACE_GALLERY,
  gallerySizeType: 'px',
  enableInfiniteScroll: false,
  cubeRatio: DEFAULT_CROP_RATIO,
  m_numberOfImagesPerRow: MOBILE_GRID_DEFAULT_COUNT_ITEM_IN_ROW,
};

export const COLLAGE_LAYOUT = {
  ...GLOBAL_OPTIONS,
  galleryLayout: GALLERY_LAYOUT_COLLAGE,
  gridStyle: 1,
  galleryMargin: DESK_DEFAULT_SPACE_GALLERY,
  gallerySizeType: 'px',
  enableInfiniteScroll: false,
  cubeImages: true,
};

export const COLLAGE_LAYOUTS_OPTIONS = {
  LARGE: {
    rotatingGroupTypes: '3r,3l,3h,3h',
    groupsPerStrip: 1,
    numRows: 2,
    numberOfImagesPerRow: 3,
    loadItemsOnSection: 3,
  },
  MEDIUM: {
    rotatingGroupTypes: '2v,3r,3l,2v,2v,3l',
    groupsPerStrip: 2,
    numRows: 2,
    numberOfImagesPerRow: 4,
    loadItemsOnSection: 5,
  },
  SMALL: {
    rotatingGroupTypes: '3b,3v,3t,3v,3t,3b,3b,3t,3v',
    groupsPerStrip: 3,
    numRows: 3,
    numberOfImagesPerRow: 5,
    loadItemsOnSection: 9,
  },
  XSMALL: {
    rotatingGroupTypes: '3b,3v,3t,3v',
    groupsPerStrip: 4,
    numRows: 3,
    numberOfImagesPerRow: 6,
    loadItemsOnSection: 12,
  },
};

export const SLIDER_LAYOUT = {
  ...GLOBAL_OPTIONS,
  galleryLayout: GALLERY_LAYOUT_SLIDER,
  galleryMargin: DESK_DEFAULT_SPACE_GALLERY,
};

export const SLIDER_LAYOUT_MOBILE = {
  ...GLOBAL_OPTIONS,
  galleryLayout: GALLERY_LAYOUT_SLIDER,
  arrowsSize: SLIDER_ARROW_SETTINGS_MOBILE.SIZE,
  arrowsPadding: SLIDER_ARROW_SETTINGS_MOBILE.PADDING,
};
